var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.007,
    height: 30.007,
    viewBox: "0 0 30.007 30.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-link",
    "data-name": "Icon awesome-link",
    d: "M19.142,10.865a8.9,8.9,0,0,1,.021,12.577l-.021.022L15.2,27.4a8.908,8.908,0,0,1-12.6-12.6L4.78,12.629a.937.937,0,0,1,1.6.622,10.8,10.8,0,0,0,.568,3.09.943.943,0,0,1-.222.974l-.767.767a4.22,4.22,0,1,0,5.929,6.006l3.938-3.938a4.219,4.219,0,0,0,0-5.968,4.39,4.39,0,0,0-.606-.5.94.94,0,0,1-.407-.739,2.334,2.334,0,0,1,.686-1.747l1.234-1.234a.941.941,0,0,1,1.206-.1,8.937,8.937,0,0,1,1.2,1.008Zm8.26-8.26a8.918,8.918,0,0,0-12.6,0L10.865,6.544l-.021.022A8.91,8.91,0,0,0,12.068,20.15a.942.942,0,0,0,1.206-.1l1.234-1.234a2.334,2.334,0,0,0,.686-1.747.94.94,0,0,0-.407-.739,4.39,4.39,0,0,1-.606-.5,4.219,4.219,0,0,1,0-5.968L18.119,5.92a4.22,4.22,0,1,1,5.929,6.006l-.767.767a.943.943,0,0,0-.222.974,10.8,10.8,0,0,1,.568,3.09.937.937,0,0,0,1.6.622L27.4,15.2a8.918,8.918,0,0,0,0-12.6Z",
    transform: "translate(0 0)",
    fill: "#ec6461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLink);
export default __webpack_public_path__ + "static/media/createLink.2608b360be458d2cb52b0cefc6a180ad.svg";
export { ForwardRef as ReactComponent };